export class IncLabResultsListModel {
    last_name: string
    first_name: string
    pet_no: number
    pet_name: string
    code_name: string
    done_date: string
    employee_initial: string 

    constructor(
        last_name: string,
        first_name: string,
        pet_no: number,
        pet_name: string,
        code_name: string,
        done_date: string,
        employee_initial: string 
    ) {
        this.last_name = last_name
        this.first_name = first_name
        this.pet_no = pet_no
        this.pet_name = pet_name
        this.code_name = code_name
        this.done_date = done_date
        this.employee_initial = employee_initial
    }
} 


export class IncLabResultsListSingleModel {
    pet_name: string
    last_name: string
    link_no: number
    link_type: number
    done_date: string
    employee_initial: string
    procedure_code: string
    procedure_desc: string
    history_sequence: number 

    constructor(
        pet_name: string,
        last_name: string,
        link_no: number,
        link_type: number,
        done_date: string,
        employee_initial: string,
        procedure_code: string,
        procedure_desc: string,
        history_sequence: number,  
    ) {
        this.pet_name = pet_name
        this.last_name = last_name
        this.link_no = link_no
        this.link_type = link_type
        this.done_date = done_date
        this.employee_initial = employee_initial
        this.procedure_code = procedure_code
        this.procedure_desc = procedure_desc
        this.history_sequence = history_sequence
    }
} 